/* eslint-disable object-curly-spacing */
import { createSlice } from '@reduxjs/toolkit';
import { getCurrentLanguage } from '../helpers/language-switcher';

const initialState = {
  isFullLoading: true,
  slsHrMobileLanguage: getCurrentLanguage(),
  isToDisableTPPPApp: false,
  disableTPPPAppEndDate: '',
  disableTPPPTempClose: false,
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setFullLoading: (state, action) => {
      return {
        ...state,
        isFullLoading: action.payload,
      };
    },
    setAppLanguage: (state, action) => {
      return {
        ...state,
        slsHrMobileLanguage: action.payload,
      };
    },
    setDisableTPPPApp: (state, action) => {
      return {
        ...state,
        isToDisableTPPPApp: action.payload,
      };
    },
    setDisableTPPPAppEndDate: (state, action) => {
      return {
        ...state,
        disableTPPPAppEndDate: action.payload,
      };
    },
    setDisableTPPPTempClose: (state, action) => {
      return {
        ...state,
        disableTPPPTempClose: action.payload,
      };
    },
  },
});

export const {
  setFullLoading,
  setAppLanguage,
  setDisableTPPPApp,
  setDisableTPPPAppEndDate,
  setDisableTPPPTempClose,
} = appSlice.actions;
export default appSlice.reducer;
